export default __webpack_public_path__ + "static/media/placeholder_dummy2016-massagestudio01-mobile-de.a7afc606.png";